import {getOperatorStepMarker, stepIconName, stepColor, stepTitle, formatDate, getBicycleIcon, realTimeStepIcon} from 'js/lib/planner'
import AgencyLink from './_agency-link'
import template from './_sidepanel-selected-route.pug'
import Tooltip from 'js/components/tooltip';

// @vue/component
export default {
  template: template(),
  components: {
    AgencyLink,
    Tooltip
  },
  props: {
    route: {
      type: Object,
      required: true
    },
    bikeStops: {
      type: Array,
      required: true
    },
    isValencia: {
      type: Boolean,
      required: true
    },
    isMurcia: {
      type: Boolean,
      required: true
    },
    isGc: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      showStops: []
    }
  },
  computed: {
    leg() {
      return this.route.leg
    },
    steps() {
      return this.leg.steps
    },
    uniqueAgencies() {
      return this.agencies.filter((agency, index) => index === this.indexOfAgency(agency))
    },
    agencies() {
      return this.steps.map(this.getAgency).filter(Boolean)
    },
    isNotSpecificModes() {
      return (step) => {
        const excludedModes = ['MOTORCYCLE', 'TAXI', 'BICYCLE', 'CAR'];
        return !excludedModes.includes(step.mode);
      };
    },
    isSpecificOrWalkMode() {
      return (step) => {
        const specificModes = ['MOTORCYCLE', 'TAXI', 'BICYCLE', 'CAR', 'WALK'];
        return specificModes.includes(step.mode);
      };
    },

    bicycleOperator() {
      return getBicycleIcon
    },

    onlyWalk(){
      return this.route?.leg.steps.every((step) => step.travel_mode === 'WALKING');
    },
    onlyBike(){
      return this.route?.leg.steps.every((step) => step.mode === 'BICYCLE');
    },

    onlyBikeRent(){
      return this.route?.leg.steps.some((step) => step.rentedBike);
    },
  },
  methods: {
    stepIconName,
    stepTitle,
    formatDate,
    realTimeStepIcon,
    stepColor(step) {
      return stepColor(step, {acceptWhite: false})
    },
    getAgency(step) {
      return _.get(step, 'transit.line.agencies[0]')
    },
    indexOfAgency(agency) {
      return this.agencies.findIndex(current => JSON.stringify(agency) === JSON.stringify(current))
    },
    stepTime(step, index) {
      return _.get(step, 'transit.departure_time.text') ||
        _.get(this.leg.steps, `[${index - 1}].transit.arrival_time.text`)
    },
    departureTimeText(leg) {
      return _.get(leg, 'departure_time.text')
    },
    arrivalTimeText(leg) {
      return _.get(leg, 'arrival_time.text')
    },
    lineShortName(step) {
      const {short_name: shortName, name} = _.get(step, 'transit.line') || {}

      return shortName || name
    },
    //Tomamos la hora de salida si existe
    departureTime(step){
      if(!step.transit) return '';
      return step.transit.departure_time.text.split(' ')[2]; //Solo la hora
    },
    // Captura logo operador
    operatorStepMarker(step ) {
      return getOperatorStepMarker( step )
    },

    toggleStops(index) {
      this.$set(this.showStops, index, !this.showStops[index])
    },

    logStop(stop) {
      return ''; // O devuelve el valor que quieras mostrar, pero el propósito aquí es solo loguear los datos.
    },
    
    // Metodo para obtener las bicicletas disponibles en la parada de inicio de Bicycle_rent
    getBikesAvailability(step) {
      if ( this.bikeStops !== undefined ) {
        const stopBike = this.bikeStops.find(bikeStop => bikeStop.id === step.info_id_rent_bicicle_stops.from);
        return stopBike.bikesAvailable;
      }
      return 0;
    },

    // Metodo para obtener las bornas disponibles en la parada de inicio de Bicycle_rent
    getBornasAvailability(step) {
      if ( this.bikeStops !== undefined ) {
        const stopBike = this.bikeStops.find(bikeStop => bikeStop.id === step.info_id_rent_bicicle_stops.to);
        return stopBike.spacesAvailable;
      }
      return 0;
    },

    // Metodo para obtener la dirección de la parada de Bicycle_rent
    getDirectionsStopsBikes(step, current ) {
      let stopBike = ''
      if ( this.bikeStops && this.bikeStops !== undefined ) {
        if( current === 'to' ) {
          stopBike = this.bikeStops.find(bikeStop => bikeStop.id === step.info_id_rent_bicicle_stops.to);
        }else {
          stopBike = this.bikeStops.find(bikeStop => bikeStop.id === step.info_id_rent_bicicle_stops.from);
        }
        return stopBike.name.replace(/_/g, ' '); 
      }
      return stopBike;
    },

    // Obtiene el color del paso
    getStepStyleColor(step, property) {
      if (step.transit && step.transit.line) {
        if (!step.transit.line.color || this.isWhite(step.transit.line.color)) {
          return `${property}: #000`
        }
          return `${property}: #0993d5`
      }
      return ''
    },
    stepStyle(step) {
      return {
        color: step.transit.line.text_color,
        'background-color': step.transit.line.color
      }
    },
    /* Method to select the constrast color of the parameter */
    isWhite(color) {
      const r = parseInt(color.substr(1, 2), 16)
      const g = parseInt(color.substr(3, 2), 16)
      const b = parseInt(color.substr(5, 2), 16)
      const hexColor = ((r * 299) + (g * 587) + (b * 114)) / 1000

      return hexColor >= 252
    }
  }
}
